import {
    Box,
    Flex,
    HStack,
    Text,
    VStack,
} from "@chakra-ui/react";

import Card from "../../Dashboard/components/Card";

const GrowthChart = ({
    milestones = [],
    commissions = [],
    payouts = [],
}) => {
const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
];

const currentYear =
    new Date().getFullYear();

const data = monthNames.map(
    (month, index) => {
        const milestone =
            milestones
                .filter(item => {
                    const date =
                        new Date(
                            item.updated_at ||
                                item.created_at
                        );

                    return (
                        item.commission_status ===
                            "Paid" &&
                        date.getMonth() ===
                            index &&
                        date.getFullYear() ===
                            currentYear
                    );
                })
                .reduce(
                    (sum, item) =>
                        sum +
                        Number(
                            item.commission_amount ||
                                0
                        ),
                    0
                );

        const delivery =
    payouts
        .filter(item => {
            if (
                !item.commission_id ||
                item.status !== "Paid"
            ) {
                return false;
            }

            const date = new Date(
                item.paid_at ||
                item.created_at
            );

            return (
                date.getMonth() ===
                    index &&
                date.getFullYear() ===
                    currentYear
            );
        })
        .reduce(
            (sum, item) =>
                sum +
                Number(
                    item.amount || 0
                ),
            0
        );

        return {
            month,
            milestone,
            delivery,
            total:
                milestone +
                delivery,
        };
    }
);

const max = Math.max(
    ...data.map(
        item => item.total
    ),
    1
);

    return (
        <Card h="100%">
            <Flex
                justify="space-between"
                align="center"
                mb={8}
                flexWrap="wrap"
                gap={4}
            >
                <Text
                    fontSize="2xl"
                    fontWeight="700"
                    color="#071D54"
                >
                    Monthly Earnings

                </Text>
                <HStack gap={6}>
                    <HStack>
                        <Box
                            w="12px"
                            h="12px"
                            borderRadius="full"
                            bg="#2453FF"
                        />

                        <Text fontSize="sm">
                            Milestone Earnings
                        </Text>
                    </HStack>

                    <HStack>
                        <Box
                            w="12px"
                            h="12px"
                            borderRadius="full"
                            bg="#10B981"
                        />

                        <Text fontSize="sm">
                            Delivery Earnings
                        </Text>
                    </HStack>
                </HStack>
            </Flex>
<Box overflowX="auto">
    <Flex
        h={{
            base: "280px",
            md: "360px",
        }}
        align="end"
        gap={{
            base: 3,
            md: 4,
        }}
        minW={{
            base: "720px",
            lg: "100%",
        }}
    >
               {data.map(item => {
    const totalHeight =
        (item.total / max) * 280;

    const milestoneHeight =
        item.total > 0
            ? (item.milestone /
                  item.total) *
              totalHeight
            : 0;

    const deliveryHeight =
        item.total > 0
            ? (item.delivery /
                  item.total) *
              totalHeight
            : 0;

    return (
        <VStack
            key={item.month}
            flex="1"
            justify="end"
            h="100%"
            gap={3}
        >
            <Text
                fontSize="xs"
                color="gray.500"
                fontWeight="600"
            >
                P
                {item.total.toFixed(
                    0
                )}
            </Text>

            <Flex
                direction="column"
                justify="end"
                h="300px"
                w="100%"
                borderRadius="10px 10px 0 0"
                overflow="hidden"
            >
                <Box
                    h={`${deliveryHeight}px`}
                    bg="#10B981"
                />

                <Box
                    h={`${milestoneHeight}px`}
                    bg="#2453FF"
                />
            </Flex>

            <Text
                fontSize="sm"
                color="gray.500"
                textTransform="uppercase"
            >
                {item.month}
            </Text>
        </VStack>
    );
})}
            </Flex>
            </Box>
        </Card>
    );
};

export default GrowthChart;